import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'

import { Heading } from 'Components/_theme'

import { E2E_HEADING_SECTION_KEYS } from 'Constants/e2e'
import { PORTAL_HEADING_TRANSLATION_IDS } from 'Constants/portalSection'

import { PageHeaderProps } from './PageHeader.types'

export const PageHeader = (props: PageHeaderProps) => {
  const { className = 'mb-4 mb-lg-6', portalSection, subheading } = props

  return (
    <Heading
      as={4}
      className={clsx(className)}
      data-e2e={E2E_HEADING_SECTION_KEYS[portalSection]}
      size={1}
    >
      <FormattedMessage id={PORTAL_HEADING_TRANSLATION_IDS[portalSection]} />

      {subheading && <>&nbsp;-&nbsp;{subheading}</>}
    </Heading>
  )
}
